// Os ícones do PlugChef Desktop (plugchef.desktop/src/renderer/src/components/icons.tsx), copiados como
// estão: a moldura do catálogo é a do Desktop, e o mesmo desenho nos dois lugares é o ponto. Ícone novo
// nasce lá e é copiado para cá.
import type { SVGProps } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 18, ...props }: IconProps): SVGProps<SVGSVGElement> {
  return { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', ...props };
}

export const IconGrid = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconApps = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="4" y="4" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="2" />
    <rect x="15" y="4" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="2" />
    <rect x="4" y="15" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="2" />
    <path d="M17.5 14v7M14 17.5h7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconBalcao = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M3 9h18M3 9l1.5-4h15L21 9M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconDelivery = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="7" cy="18" r="1.8" stroke="currentColor" strokeWidth="2" />
    <circle cx="17" cy="18" r="1.8" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconAgenda = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M3 9h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconWhatsapp = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.6-1.2A9 9 0 1 0 12 3z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8.7c.2-.5.5-.5.7-.5h.6c.2 0 .4 0 .6.4.2.5.6 1.6.7 1.7.1.1.1.3 0 .5-.1.2-.2.3-.4.5-.2.2-.4.3-.2.6.2.4.9 1.4 1.9 2.3 1.3 1.1 2.3 1.5 2.7 1.6.2.1.4.1.5-.1.2-.2.7-.8.9-1 .2-.2.4-.2.6-.1.2.1 1.5.7 1.8.8.3.1.4.2.5.3 0 .2 0 .8-.3 1.5-.2.7-1.5 1.4-2.1 1.4-.6.1-1.2.1-4-1.1-3.4-1.4-5.5-4.8-5.7-5-.1-.2-1.2-1.6-1.2-3.1 0-1.5.8-2.2 1-2.5z"
      fill="currentColor"
    />
  </svg>
);

export const IconStore = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M3 21V9l9-6 9 6v12M9 21v-6h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconClock = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconActivity = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M22 12h-4l-3 9-6-18-3 9H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconWallet = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconSearch = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
    <path d="m20 20-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconBell = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M9.5 21a2.5 2.5 0 0 0 5 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPrinter = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M6 14h12v7H6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Balança de pratos: haste central, base e os dois pratos de pesagem.
export const IconScale = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M12 3v18M8 21h8M3 7h18M7 7l-3 7h6zM17 7l-3 7h6z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconChevronLeft = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconX = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const IconEdit = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m14 8 2 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconPlus = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const IconMinus = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const IconTrash = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconSettings = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => (
      <rect key={angle} x="10" y="1.8" width="4" height="3.2" rx="0.8" fill="currentColor" transform={`rotate(${angle} 12 12)`} />
    ))}
    <circle cx="12" cy="12" r="6.2" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="2.4" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconCardapio = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 3v8a2 2 0 0 0 4 0V3M8 13v8M16 3c-1.5 0-3 1.5-3 4s1.5 4 3 4v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPizza = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 2 3 20h18L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" />
    <circle cx="10" cy="16" r="1.2" fill="currentColor" />
    <circle cx="14" cy="16" r="1.2" fill="currentColor" />
  </svg>
);

export const IconCombo = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M5 9h9l1 12H4L5 9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 9V7a2.5 2.5 0 0 1 5 0v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 22V10a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconEstoque = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M21 8V6a1 1 0 0 0-.5-.87l-8-4.5a1 1 0 0 0-1 0l-8 4.5A1 1 0 0 0 3 6v12a1 1 0 0 0 .5.87l8 4.5a1 1 0 0 0 1 0M3.5 6 12 11l8.5-5M12 22V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPdv = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M3 4h2l2.5 13h11l2-8H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="18" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconCaixa = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M3 9h18M7 14h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconRelatorios = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 20V4M4 20h16M8 16v-4M13 16V8M18 16v-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconClientes = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="2" />
    <path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconCamera = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <circle cx="12" cy="14" r="3.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconCheckCircle = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="m8 12 3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconUsersGroup = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M3 20c0-3 2.5-5 6-5s6 2 6 5M16 6a3 3 0 0 1 0 6M18 20c0-2-1-3.5-2.5-4.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconOrders = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M3 4h2l2.5 13h11l2-8H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="9" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="18" cy="20" r="1.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconRevenue = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPreparo = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 21h16M6 21V10a6 6 0 0 1 12 0v11M9 4V2M15 4V2M12 4V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconUser = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
    <path d="M4 20c0-3.9 3.6-7 8-7s8 3.1 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconLogout = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M15 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3M10 17l5-5-5-5M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconLock = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="4" y="11" width="16" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconChevronDown = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChevronRight = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="m9 5 7 7-7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconRefresh = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36M21 4v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Nuvem cortada — "sem transmissão à SEFAZ". Usado no card de contingência manual. */
export const IconCloudOff = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M18.5 18H7a4.5 4.5 0 0 1-.9-8.91M9.3 5.4A5.5 5.5 0 0 1 17.5 10h.5a4 4 0 0 1 3 6.65"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="m3 3 18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconSend = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconHelp = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M9.2 9.3a2.8 2.8 0 0 1 5.4 1c0 1.9-2.6 2.3-2.6 3.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="17.2" r="1.1" fill="currentColor" />
  </svg>
);

export const IconDotsVertical = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="5" r="1.6" fill="currentColor" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    <circle cx="12" cy="19" r="1.6" fill="currentColor" />
  </svg>
);

export const IconCopy = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="9" y="9" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconGripVertical = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="9" cy="6" r="1.6" fill="currentColor" />
    <circle cx="9" cy="12" r="1.6" fill="currentColor" />
    <circle cx="9" cy="18" r="1.6" fill="currentColor" />
    <circle cx="15" cy="6" r="1.6" fill="currentColor" />
    <circle cx="15" cy="12" r="1.6" fill="currentColor" />
    <circle cx="15" cy="18" r="1.6" fill="currentColor" />
  </svg>
);

export const IconBox = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 2v6a6 6 0 0 0 12 0V2M4 22h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconAi = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M11.5 3 9 9l-6 2.5L9 14l2.5 6 2.5-6 6-2.5-6-2.5-2.5-6Z"
      fill="currentColor"
    />
    <path d="M18.5 14.5 17.4 17l-2.4 1 2.4 1 1.1 2.5 1.1-2.5 2.4-1-2.4-1-1.1-2.5Z" fill="currentColor" opacity="0.7" />
  </svg>
);

export const IconGroupOrders = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="3" y="4" width="11" height="13" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M7 8h3M7 12h3M9 20h8a4 4 0 0 0 4-4V9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="m18 6 3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconSun = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 2.5v2M12 19.5v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2.5 12h2M19.5 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconMoon = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M20 14.5A8.5 8.5 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconEye = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconEyeOff = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M10.6 6.2A9.7 9.7 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.3 4M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 4.9-1.3M9.9 9.9a3 3 0 0 0 4.2 4.2M3 3l18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Cifrão circulado — distinto do IconWallet (rect, já usado pelo Caixa/IconCaixa) e do
// IconRelatorios (barras), pro ícone dedicado de Financeiro na Sidebar.
export const IconFinanceiro = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 6.5v11M15.2 9.3c0-1.3-1.3-2.3-3.2-2.3s-3.2.9-3.2 2.2c0 3 6.4 1.5 6.4 4.5 0 1.3-1.4 2.3-3.2 2.3s-3.2-1-3.2-2.3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowUp = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconArrowDown = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 5v14M5 12l7 7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// -- Ícones das seções da tela de cadastro de produto (ProdutoCadastroModal) --

export const IconDocLines = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="4" y="3" width="16" height="18" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M8 8h8M8 12h8M8 16h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const IconPriceTag = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M20.6 13.3 12 21.9 3.4 13.3a3 3 0 0 1 0-4.2l5.7-5.7a2 2 0 0 1 1.4-.6H16a2 2 0 0 1 2 2v5.5a2 2 0 0 1-.6 1.4"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="14.5" cy="8.5" r="1.2" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

export const IconFiscalDoc = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 8h6M9 12h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const IconFichaTecnica = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="5" y="4" width="14" height="17" rx="2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M9 3h6v3H9z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const IconBarcodeLines = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 6v12M7.5 6v12M10 6v12M13 6v12M16.5 6v12M20 6v12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconResize = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 10V4h6M20 14v6h-6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 4l7 7M20 20l-7-7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const IconPause = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor" />
    <rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor" />
  </svg>
);

// Inspirado no símbolo do iFood (o "smiley": dois olhos + seta-sorriso), redesenhado no
// estilo monocromático outline do resto do ícone set (não é o logo oficial em cores).
export const IconIfood = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="9.4" cy="10.1" rx="2" ry="2.5" fill="currentColor" transform="rotate(-18 9.4 10.1)" />
    <ellipse cx="14.3" cy="9.8" rx="2" ry="2.5" fill="currentColor" transform="rotate(12 14.3 9.8)" />
    <path d="M7.6 14c1.7 2.1 5.1 2.9 7.5 1.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M13.4 13.6l1.9 1.6-0.8 2.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Icon99Food = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <text x="12" y="16" textAnchor="middle" fontSize="9" fontWeight="700" fill="currentColor" stroke="none">
      99
    </text>
  </svg>
);

// AiqFome: monograma neutro (não é a marca deles), no mesmo estilo do 99Food.
export const IconAiqfome = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <text x="12" y="16" textAnchor="middle" fontSize="9" fontWeight="700" fill="currentColor" stroke="none">
      aq
    </text>
  </svg>
);

// Controles da janela (barra de título própria, sem moldura nativa — ver TopBar.tsx)
export const IconWindowMinimize = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M5 12h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconWindowMaximize = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="5.5" y="5.5" width="13" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

export const IconWindowRestore = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="8" y="4.5" width="11.5" height="11.5" rx="1.4" stroke="currentColor" strokeWidth="1.4" />
    <path d="M4.5 8H14a1.5 1.5 0 0 1 1.5 1.5V19a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 19V8Z" fill="var(--bg)" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

export const IconWindowClose = IconX;

export const IconDownload = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 3v12m0 0 4-4m-4 4-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconFilter = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M4 5h16l-6.5 7.5V19l-3 2v-8.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconUpload = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M12 15V3m0 0 4 4m-4-4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 15v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPaperclip = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path
      d="M21 11.5 12.5 20a4.5 4.5 0 0 1-6.36-6.36L14.5 5.3a3 3 0 0 1 4.24 4.24l-8.13 8.13a1.5 1.5 0 0 1-2.12-2.12l7.42-7.42"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Maquininha/adquirente de cartão (débito/crédito do cliente) — distinto de IconWallet (saldo).
export const IconCreditCard = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="2.5" y="5" width="19" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M2.5 10h19" stroke="currentColor" strokeWidth="2" />
    <path d="M6 14.5h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Monitoramento de recursos da máquina (badges do TopBar) — chip de processador.
export const IconCpu = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="6" y="6" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <rect x="9.5" y="9.5" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9 2v3M12 2v3M15 2v3M9 19v3M12 19v3M15 19v3M2 9h3M2 12h3M2 15h3M19 9h3M19 12h3M19 15h3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconMemory = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <rect x="2.5" y="7" width="19" height="10" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <path
      d="M6 7V4.5M10 7V4.5M14 7V4.5M18 7V4.5M6 19.5V17M10 19.5V17M14 19.5V17M18 19.5V17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Reserva de mesa — bookmark/etiqueta, distinto do IconAgenda (calendário, usado por Pedidos Agendados).
export const IconBookmark = (p: IconProps): JSX.Element => (
  <svg {...base(p)}>
    <path d="M6 3.5h12a1 1 0 0 1 1 1V21l-7-4-7 4V4.5a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);
